import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import appconst from '@/lib/appconst';


interface ListedHistoryState extends ListState<any> {
}

class ListedHistoryMutations extends ListMutations<any>{

}
class ListedHistory extends ListModule<ListedHistoryState, any, any>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
    }
    actions = {
        async getAll(context: ActionContext<ListedHistoryState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/FrontListedHistory/GetList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        }



    };
    mutations = {
        setCurrentPage(state: ListedHistoryState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ListedHistoryState, pagesize: number) {
            state.pageSize = pagesize;
        },
    };
}





const listedHistory = new ListedHistory();
export default listedHistory;